const TextBox = ({ label, value, onChange, placeholder, type='text', disabled, error, helperText, className, name }) => {
  return (
    <div className={`relative ${className} mb-[20px]`}>
      <label className='text-[14px] text-gray-700 font-bold mb-[10px]'>{label}</label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`bg-white border-[1px] border-[#D9D9D9] rounded-[5px] h-[42px] w-full px-[15px] text-[14px] focus:outline-none focus:border-taction focus:ring-1 focus:ring-taction`}
        disabled={disabled}
      />
      {error && <p className='text-red-500 text-[12px] mt-[5px]'>{error}</p>}
      {helperText && <p className='text-[12px] text-taction mt-[5px]'>{helperText}</p>}
    </div>
  );
};

export default TextBox;